import { render } from "./TheMainMenu.vue?vue&type=template&id=380fad4e"
import script from "./TheMainMenu.vue?vue&type=script&lang=js"
export * from "./TheMainMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__